<template>
    <el-container class="vyhlidkove-lety">
      <div class="nabidky-wrapper">

      <div class="nabidky-content">
        <h1>Lety pro veřejnost</h1>
        <p>
          Nabízíme zážitkové lety pro jednu osobu v ultralehkém letounu.<br> 
          U nás máte také možnost pilotování si sami vyzkoušet.
        </p>
        <div style="display: flex; flex-direction: row; justify-content: flex-end;">
          <el-button class="btn-el" @click="router.push('/zazitkovelety')" >Zážitkový let</el-button>
          <el-button class="btn-el" @click="router.push('/zazitkovelety#pilotemnazkousku')" >Pilotem na zkoušku</el-button>
        </div>
      </div>

      <div class="nabidky-carousel">
        <el-carousel>
          <el-carousel-item v-for="item in photos_url" :key="item">
            <!-- <img :src="'../../src/assets/photos/img'+item+'.jpg'" loading="lazy">  -->
            <img :src="item" loading="lazy">
            <!-- <h3 class="small">{{ item }}</h3> -->
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    </el-container>
</template>

<script>
import { useRouter } from 'vue-router'

export default {
    name: "VyhlidkoveLety",
    setup(){
      const router =  useRouter();
      let photos_url = [];

      for(let img_n of [2,8,12,32]){ //[2,8,12,20,32]
        photos_url.push(require("../../src/assets/photos/img"+String(img_n)+".jpg"))
      }

      return {router, photos_url}
    }
}
</script>


<style scoped>

.btn-el{
  width: 225px;
  background: #ffffff;
  color: #495052;
  border-width: 1px;
  font-size: 17px;
}

.btn-el:hover{
  background: #74949c;
  color: #ffffff;
  border-color: #74949c; 
}

.vyhlidkove-lety {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 100%;

  /* background: linear-gradient(180deg, #ffffff,#ffffff, #dee8f1); */
  background: linear-gradient(180deg, #ffffff,#ffffff, #ebeef0);
  padding-top: 20px;
  padding-bottom: 20px;
}

.nabidky-wrapper{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  overflow: hidden;
  width: 100%;

}

.nabidky-content{
  margin: 20px;
  width: 50%;
  max-width: 600px;
  flex-grow: 1;
  text-align: right;
}

.nabidky-carousel{
  margin: 20px;
  max-width: 600px;
  min-width: 410px;
  flex-grow: 1;
}

.el-carousel__item img {
  max-width: 100%;
}
</style>